var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotickets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "2500 2536 15000 1528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n.fil1 {\r\n  fill: #011327;\r\n  fill-rule: nonzero;\r\n}\r\n.fil2 {\r\n  fill: #3899f8;\r\n  fill-rule: nonzero;\r\n}\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TICKETS"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_1Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M7363 4064l0 -1180 679 0 0 -348 -1748 0 0 348 676 0 0 1180 393 0zm8592 0l1081 0c278,0 464,-186 464,-465l0 -88c0,-269 -186,-407 -464,-407l-655 0c-57,0 -78,-44 -78,-98l0 -21c0,-73 48,-101 124,-101l1029 0 0 -348 -1080 0c-279,0 -465,186 -465,465l0 86c0,274 186,409 465,409l656 0c44,0 75,40 75,98l0 19c0,75 -48,100 -121,100l-1031 0 0 351zm-833 0l0 -1180 679 0 0 -348 -1748 0 0 348 676 0 0 1180 393 0zm-1216 -1528l-1504 0 0 1528 1504 0 0 -351 -1111 0 0 -240 1019 0 0 -348 -1019 0 0 -241 1111 0 0 -348zm-3045 1528l0 -384 338 -286 579 670 520 0 -798 -925 712 -603 -541 0 -810 685 0 -685 -393 0 0 1528 393 0zm-574 0l0 -351 -988 0c-75,0 -123,-48 -123,-121l0 -584c0,-76 48,-124 123,-124l988 0 0 -348 -1038 0c-280,0 -466,186 -466,465l0 598c0,279 186,465 466,465l1038 0zm-1668 0l0 -1528 -393 0 0 1528 393 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "GO"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_2Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M4238 3125l-938 0 0 348 545 0 0 119c0,73 -48,121 -121,121l-708 0c-75,0 -123,-48 -123,-121l0 -584c0,-76 48,-124 123,-124l1165 0 0 -348 -1215 0c-280,0 -466,186 -466,465l0 598c0,279 186,465 466,465l808 0c280,0 464,-186 464,-465l0 -474zm653 939l808 0c280,0 464,-186 464,-465l0 -598c0,-279 -184,-465 -464,-465l-808 0c-280,0 -466,186 -466,465l0 598c0,279 186,465 466,465zm50 -351c-75,0 -123,-48 -123,-121l0 -584c0,-76 48,-124 123,-124l708 0c73,0 121,48 121,124l0 584c0,73 -48,121 -121,121l-708 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotickets);
export default __webpack_public_path__ + "static/media/gotickets.17552a0bb2c5e82d63f7b1c746c5c36b.svg";
export { ForwardRef as ReactComponent };